<template>
  <div>
    <el-checkbox-group v-model="checkList" @change="changeCheck">
      <draggable v-model="SortDrag" @sort="draggerEnd">
        <transition-group type="transition" name="flip-list">
          <el-checkbox v-for="item in SortDrag" :key="item.id" :label="item.id"
            >{{ item.profileName }}
          </el-checkbox>
        </transition-group>
      </draggable>
    </el-checkbox-group>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  props: ["dragData"],
  data() {
    return {
      checkList: [],
      newDrag: [],
      SortDrag: [],
      dragList: [],
    };
  },
  created() {
    if (this.dragData) {
      let arr = [];
      this.dragData.map((item, index) => {
        if (item.check === 1) {
          arr.push(item.id);
        }
      });
      this.checkList = [...arr];
      console.log(this.checkList);
    }
    this.SortDrag = [...this.dragData];
    console.log(this.SortDrag);
  },
  mounted() {
    this.sortFun();
  },
  methods: {
    sortFun() {
      this.newDrag = this.SortDrag;
      let length = this.checkList.length;
      this.dragList = [];
      if (length > 0) {
        this.newDrag.map((items, index) => {
          this.checkList.map((item, t) => {
            if (items.id === item) {
              this.dragList.push(items);
            }
          });
        });
      }
    },
    changeCheck(e) {
      this.$emit("changeCheck", e);
    },
    draggerEnd(e) {
      this.$emit("draggerEnd", this.SortDrag);
    },
  },
};
</script>
